import React from "react";
import { Row, Col} from "react-bootstrap";
import { experienes } from "../Models"

function Experience() {
  return (

    <div class="card">
<div class="card-header" style={{textAlign:"left"}}>
  <h3>Experience</h3>
</div>
<div class="card">
        {experienes.map((exp) => (
            <div>
            
            <Row>
            <Col md={7} className="project-card" style={{textAlign:"left"}}>
            <h5 style={{fontWeight: "bold"}}>{exp.title}</h5> 
            <p>{exp.description}</p>
            {/* <a href={exp.link} style={{color:"black"}}>Certificate</a> */}
          </Col>
          <Col md={4} className="project-card">
                <a href={exp.link} target="_blank" rel="noreferrer">
              <img src={exp.image} alt={exp.title} className="project_card_img" />
              </a>
          </Col>
          </Row>
          </div>
          ))}

       </div>
</div>

);
}

export default Experience;